import Restricted from '../../components/Restricted/Restricted';
import { Link } from 'react-router-dom';
import { BsPencilSquare } from 'react-icons/bs';
import Icon from '../../components/Icon/Icon';
import { useAuth } from '../../hooks/useAuth';
import { GTMsendEvent } from '../../utils/trackingGA4';
import { RoleEnum } from 'src/api';

export const LinkToForm = ({ data }) => {
	const { userRole } = useAuth();

	const handleClick = () => {
		GTMsendEvent({
			event: 'CTA_modify_dealer',
			evtCat: 'dealer',
			evtAct: 'modify',
			evtLab: `modify_dealer`,
		});
	};
	return (
		<Restricted
			to={[
				RoleEnum.BACKOFFICE,
				RoleEnum.SALES,
				RoleEnum.SALES_DEALER,
				RoleEnum.SALES_INTERNAL,
				RoleEnum.MASTER,
				RoleEnum.ADMIN,
				RoleEnum.AREA_MANAGER,
			]}
		>
			<div onClick={handleClick}>
				{[
					RoleEnum.BACKOFFICE,
					RoleEnum.MASTER,
					RoleEnum.ADMIN,
					RoleEnum.AREA_MANAGER,
				].includes(userRole) ? (
					<Link to={`/manage-dealers/${data.row.original.id}`} className="btn">
						<BsPencilSquare
							style={{ width: '1.2rem', height: '1.6rem' }}
							name="edit"
						/>
					</Link>
				) : (
					<Link to={`/manage-dealers/${data.row.original.id}`} className="btn">
						<Icon
							style={{ width: '1.2rem', height: '1.2rem' }}
							name="arrow-right"
						/>
					</Link>
				)}
			</div>
		</Restricted>
	);
};
